import clsx from 'clsx'

import { useTranslation } from '@/shared/hooks/useTranslation'
import { Button } from '@/shared/ui/Button'

type QuizSortedWordsProps = {
  pool: string[]
  value: string[]
  disabled?: boolean
  onChange: (value: string[]) => void
}

export function QuizSortedWords({ pool, value, disabled, onChange }: QuizSortedWordsProps) {
  const { t } = useTranslation()

  const addWord = (word: string) => {
    onChange([...value, word])
  }

  const removeAt = (index: number) => {
    onChange(value.filter((_, i) => i !== index))
  }

  const availableCounts = new Map<string, number>()
  pool.forEach(word => availableCounts.set(word, (availableCounts.get(word) ?? 0) + 1))
  value.forEach(word => availableCounts.set(word, (availableCounts.get(word) ?? 0) - 1))

  return (
    <div className="flex w-full flex-col gap-3">
      <p className="m-0 text-xs text-gray-500">{t('quests.quiz.sortedInstruction')}</p>

      <div className="flex min-h-12 flex-wrap gap-2 rounded-xl border border-dashed border-gray-300 p-2">
        {value.map((word, index) => (
          <button
            key={`${word}-${index}`}
            type="button"
            disabled={disabled}
            onClick={() => removeAt(index)}
            className="rounded-full bg-[var(--color-brand)] px-3 py-1 text-xs font-bold text-[var(--color-brand-inverse)]"
          >
            {word}
          </button>
        ))}
      </div>

      <div className="flex flex-wrap gap-2">
        {pool.map((word, index) => {
          const remaining = availableCounts.get(word) ?? 0
          if (remaining <= 0) return null

          return (
            <button
              key={`${word}-${index}`}
              type="button"
              disabled={disabled}
              onClick={() => addWord(word)}
              className={clsx(
                'rounded-full border border-gray-200 bg-white px-3 py-1 text-xs font-medium text-gray-700'
              )}
            >
              {word}
            </button>
          )
        })}
      </div>

      {value.length > 0 && (
        <Button variant="ghost" size="sm" disabled={disabled} onClick={() => onChange([])}>
          {t('quests.quiz.sortedClear')}
        </Button>
      )}
    </div>
  )
}
